import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-two-column-media-right',
    templateUrl: './two-column-media-right.component.html',
    styleUrls: ['./two-column-media-right.component.scss']
})
export class TwoColumnMediaRightComponent implements OnInit {

    @Input() icon: any = '';
    @Input() title: any = '';
    @Input() subtitle: any = '';
    @Input() description: any = '';
    @Input() url: any = '';
    @Input() thumbnail: any = '';
    @Input() width: any = '';
    @Input() button: any = 'Learn more';

    serverUrl: string = environment.webUrl;

    constructor() { }

    ngOnInit(): void {
    }

}
